export default "__VITE_ASSET__2w9$lVFR__"